import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import Chip from "@material-ui/core/Chip";
import Radio from "@material-ui/core/Radio";
import { navigate } from "@reach/router";
import Button from "@material-ui/core/Button";
import { SUBSCRIPTION_ACTION_TYPES } from "../../redux-saga/actionTypes/index";
import styles from "./styles";

class Products extends React.Component {
  constructor() {
    super();
    this.state = {
      radioSelection: ""
    };
  }

  handleRadio(radioSelection) {
    this.setState({
      radioSelection
    });
  }

  handleClick() {
    const { list, setProduct } = this.props;
    const { radioSelection } = this.state;
    setProduct(list[radioSelection]);
    navigate("summary");
  }

  render() {
    const { classes, t, nickname, list } = this.props;
    return (
      <React.Fragment>
        <div className={classes.headerSection}>
          <i
            className={`material-icons ${classes.headerIcon}`}
            onClick={() => navigate("profiles")}
          >
            keyboard_arrow_left
          </i>
          <h4 className={classes.headerBreadCrumb}>
            {t("screens.products.breadCrumb")}
          </h4>
        </div>
        <div className={classes.body}>
          <div className={classes.titleSection}>
            <h1 className={classes.title}>{t("screens.products.title")}</h1>
            <h2 className={classes.subTitle}>{nickname}</h2>
          </div>
          <div className={classes.listSection}>
            {list.map((item, index) => (
              <div className={classes.listItem}>
                <Chip
                  className={classes.listChip}
                  key={item.packageName}
                  label={`$${item.price}`}
                />
                <h3 className={classes.listProduct}>{item.packageName}</h3>
                <Radio
                  onClick={() => this.handleRadio(index)}
                  value="index"
                  name="radio-button-demo"
                />
              </div>
            ))}
          </div>
          <div className={classes.actionsSection}>
            <Button
              onClick={() => this.handleClick()}
              className={classes.actions}
              variant="contained"
              size="large"
              color="primary"
            >
              {t("screens.products.action")}
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Products.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  list: PropTypes.array,
  setProduct: PropTypes.func.isRequired
};

Products.defaultProps = {
  list: []
};

const mapStateToProps = ({ up, products }) => ({
  nickname: up.profile.nickname,
  list: products.products
});

const mapDispatchToProps = dispatch => ({
  setProduct: payload =>
    dispatch({
      type: SUBSCRIPTION_ACTION_TYPES.PRODUCTS.SET_SELECTED_PRODUCT,
      payload
    })
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(Products))
);
